import { Link as _Link } from 'react-router-dom'
import styled from 'styled-components'

import { applyIPadOnlyStyle } from 'helpers/css'

export const Container = styled.div`
    width: 98%;
    height: 98%;
    background: linear-gradient(0deg, #ffffff, #ffffff);
    box-sizing: border-box;
    box-shadow: 0px 14.2794px 28.5588px rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    overflow: hidden;
    ${applyIPadOnlyStyle('height:55vh')}
`

export const StyledIframe = styled.iframe`
    width: 100% !important;
    height: 100% !important;
`
